<template>
  <form
    class="nx-form nx-relation-card"
    :class="{ 'nx-active': active }"
    :data-vv-scope="scope"
  >
    <v-container class="py-0 grid-list-lg">
      <v-layout class="row wrap">
        <v-flex class="xs12">
          <v-layout class="row wrap">
            <v-flex class="xs12 md6 lg6">
              <nx-clipping-form-selector
                validation="required"
                :label="$t('message.form.fields.photogalleryMainClippingId')"
                :aspect-ratios="aspectRatios"
                :value="draft.clipping"
                :type="types"
                :title-length="7"
                allow-only-source-aspect-ratio
                name="clipping"
              />
            </v-flex>
            <v-flex class="xs12 md6 lg6">
              <nx-form-text
                name="title"
                :label="$t('message.form.fields.title')"
                :value="draft.title"
              />
              <nx-form-text
                name="signatureAuthorName"
                :label="$t('message.form.fields.author')"
                :value="draft.signatureAuthorName"
              />
              <nx-form-text-editor
                name="body"
                type="basic"
                label="Descripción"
                :value="draft.body"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </form>
</template>

<script>
import RelationMultimediaCardForm from '@/modules/relation/card/form/RelationMultimediaCardForm.vue';
import ContentSelector from '@/modules/content/selector/FormSelector.vue';
import ClippingSelector from '@/modules/clipping/form/Selector.vue';
import FormTextEditor from '@/modules/form/components/FormTextEditor.vue';


export default {
  name: 'InfolibreRelationWithMediaCard',
  components: {
    [ContentSelector.name]: ContentSelector,
    [ClippingSelector.name]: ClippingSelector,
    [FormTextEditor.name]: FormTextEditor,
  },
  extends: RelationMultimediaCardForm,
};
</script>
